<template>
    <div>
        <form v-if="officer.screen === 'bvn'" @submit.prevent="completeCreateOfficer1()">
            <div class="form-group">
                <label>BVN</label>
                <input v-model="model.bvn" type="text" maxlength="11" minlength="11" class="form-control" placeholder="Please Enter Your BVN">
            </div>
            <div class="form-group">
                <base-button
                        class="mt-3"
                        :loading="officer.createLoading"
                        title="Continue"
                ></base-button>
            </div>
        </form>
        <form  v-else-if="officer.screen === 'password'" @submit.prevent="completeCreateOfficer2()">
            <div class="form-group">
                <label>Password</label>
                <input v-model="model.password" type="password"  minlength="6" maxlength="6" class="form-control" placeholder="Please enter your password">
            </div>
            <div class="form-group">
                <base-button
                        class="mt-3"
                        :loading="officer.createLoading"
                        title="Continue"
                ></base-button>
            </div>
        </form>
        <form  v-else-if="officer.screen === 'setPassword'" @submit.prevent="completeCreateOfficer4()">
            <div class="form-group">
                <label>OTP</label>
                <input v-model="model.otp" type="text" maxlength="4" minlength="4" class="form-control" placeholder="Enter otp">
            </div>
            <div class="form-group">
                <label>Password</label>
                <input v-model="model.password" type="password" minlength="6" maxlength="6" class="form-control" placeholder="Please enter password">
            </div>
            <div class="form-group">
                <label>Retype password</label>
                <input v-model="model.passwordConfirmation" type="password" minlength="6" maxlength="6" class="form-control" placeholder="Please enter password confirmation">
            </div>
            <div class="form-group">
                <base-button
                        class="mt-3"
                        :loading="officer.createLoading"
                        title="Continue"
                ></base-button>
            </div>
        </form>
        <form  v-else-if="officer.screen === 'otp'" @submit.prevent="completeCreateOfficer4()">
            <div class="form-group">
                <label>OTP</label>
                <input v-model="model.otp" type="text" maxlength="4" minlength="4" class="form-control" placeholder="Enter otp">
            </div>
            <div class="form-group">
                <base-button
                        class="mt-3"
                        :loading="officer.createLoading"
                        title="Continue"
                ></base-button>
            </div>
        </form>
    </div>
</template>

<script>
    import BaseButton from "../button/BaseButton";
    import {mapState} from 'vuex';
    export default {
        name: "LogonForm",
        components: {
            // eslint-disable-next-line vue/no-unused-components
            mapState,
            BaseButton
        },
        data() {
            return {
                screen:'bvn',
                model: {
                    bvn: '',
                    username: '',
                    password: '',
                    passwordConfirmation:'',
                    officerEmail:'',
                    officerPhone:'',
                    otp:'',
                    token:'',
                    countryCode: '234',
                    subscribe: true
                },
            }
        },
        methods: {
            async completeCreateOfficer1() {
                // TIP use this.model to send it to api and perform register call
                this.model.dialogs = this.$dialogs;
                await this.$store.dispatch('officer/completeCreateOfficer1', this.model, {root: true});
                this.model.uniqueRef = this.officer.response.uniqueref;
                this.model.username = this.officer.response.username;

            },
            async completeCreateOfficer2() {
                // TIP use this.model to send it to api and perform register call
                this.model.dialogs = this.$dialogs;
                await this.$store.dispatch('officer/completeCreateOfficer2', this.model, {root: true});

            },
            async completeCreateOfficer3() {
                // TIP use this.model to send it to api and perform register call
                this.model.dialogs = this.$dialogs;
                await this.$store.dispatch('officer/completeCreateOfficer3', this.model, {root: true});
                this.model.officerEmail = this.officer.response.officerEmail;
                this.model.officerPhone = this.officer.response.officerPhone;
            },
            async completeCreateOfficer4() {
                // TIP use this.model to send it to api and perform register call
                this.model.dialogs = this.$dialogs;
                await this.$store.dispatch('officer/completeCreateOfficer4', this.model, {root: true});

            },
            async completeOfficerOne() {
                // TIP use this.model to send it to api and perform register call
                if (this.model.password === "" || this.model.password.length < 6) {
                    const options = {title: "Error!", size: 'sm'}
                    this.$dialogs.alert("password must equal six character", options)
                        .then(res => {
                            console.log(res) // {ok: true|false|undefined}
                        });
                    return
                }
                if ((this.model.password !== this.model.passwordConfirmation) &&  !this.model.registered) {
                    const options = {title: "Error!", size: 'sm'}
                    this.$dialogs.alert("password mismatch", options)
                        .then(res => {
                            console.log(res) // {ok: true|false|undefined}
                        });
                    return
                }
                await this.$store.dispatch('officer/initOfficerReg', this.model, {root: true})
                let res = this.officer.response
                if (res.responseCode === '00') {
                    const options = {title: "Success!", size: 'sm'}
                    this.$dialogs.alert("Your record as an officer has been updated!", options)
                        .then(res => {
                            console.log(res) // {ok: true|false|undefined}
                            this.$router.push('/');
                        });
                }

            },
        },
        computed:{
            ...mapState([
                'company',
                'document',
                'system',
                'auth',
                'officer',
            ]),
        },
        watch: {
            'auth': function() {
                console.log('Hello World!')
            }
        },
        mounted() {
            // this.$store.auth.watch(this.$store.getters.getN, n => {
            //     console.log('watched: ', n)
            // })
            this.model.officerID = this.$route.query.q
        },
    }
</script>

<style scoped>

</style>